import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveVideoWidget from './js/live-video-widget.component';

ComponentsFactory.getInstance().define('live-video-widget', LiveVideoWidget);
